// @flow
import * as React from 'react';
import { Container } from 'flux/utils';
import GroupStore from 'groups/stores/GroupStore';
import MessageActions from 'groups/actions/MessageActions';
import { SplitComposerModal } from 'chat/components/SplitComposer';

type Props = {
  onRequestHide: *,
};

type State = {
  draft: *,
};

// TODO:
//
//   - move off of flux, we don't even need a different store
//     we need <DraftedComposer /> to consume query props
//     and draft an initial message when openening the modal.
//
class DraftedComposer extends React.Component<Props, State> {
  static getStores() {
    return [GroupStore];
  }

  state: State = {
    draft: null,
  };

  static calculateState() {
    return {
      draft: GroupStore.getDraftAnnouncement(),
    };
  }

  componentDidMount() {
    MessageActions.clearDraftAnnouncement();
  }

  render() {
    const { draft } = this.state;
    const targets = draft ? draft.getTargets() : [];

    if (draft) {
      return (
        <SplitComposerModal
          initialTargets={targets}
          draftAnnouncement={draft}
          onRequestHide={this.props.onRequestHide}
          skipSelectRecipients
        />
      );
    }
    return <SplitComposerModal onRequestHide={this.props.onRequestHide} />;
  }
}

export { DraftedComposer };
export default Container.create(DraftedComposer);
